import React, { useState } from "react";
import Button from "../../../components/ui/Button/Button";
import { Dropdown } from "../../../components/ui/Dropdown/Dropdown";
import InputDate from "../../../components/ui/InputDate/InputDate";

const checkByOptions = [
  {
    id: 1,
    name: "상품명",
  },
];

const radioButton = [
  { id: 1, name: "등록 순" },
  { id: 2, name: "REF(상품코드) 순" },
  { id: 3, name: "현재 재고수량 순" },
  { id: 4, name: "총 입고수량 순" },
  { id: 5, name: "총 출고수량 순" },
  { id: 6, name: "총 조정수량 순" },
  { id: 7, name: "현재 재고수량 순" },
];

const overallRadioButton = [
  { id: 1, name: "등록 순" },
  { id: 2, name: "REF(상품코드) 순" },
  { id: 3, name: "현재 재고수량 순" },
  { id: 4, name: "총 입고수량 순" },
  { id: 5, name: "총 출고수량 순" },
  { id: 6, name: "총 조정수량 순" },
  { id: 7, name: "현재 재고수량 순" },
  { id: 8, name: "총 결제금액 순" },
  { id: 9, name: "총 환불금액 순" },
  { id: 10, name: "총 매출금액 순" },
];

const productRadioButton = [
  { id: 1, name: "등록 순" },
  { id: 2, name: "REF(상품코드) 순" },
  { id: 3, name: "총 결제금액 순" },
  { id: 4, name: "총 환불금액 순" },
  { id: 5, name: "총 매출금액 순" },
];

function Filter(props) {
  const {
    onFilter,
    onSubmitFilter,
    onResetFilter,
    categoriesData,
    isOverall,
    isProductSpread,
  } = props;
  const [discountStartDate, setDiscountStartDate] = useState(null);
  const [discountEndDate, setDiscountEndDate] = useState(null);
  const [selectedDateOption, setSelectedDateOption] = useState();

  const onChangeDiscountStartDate = (value) => {
    setDiscountStartDate(value);
    onFilter({
      from: discountStartDate?.unix(),
    });
  };

  const onChangeDiscountEndDate = (value) => {
    setDiscountEndDate(value);
    onFilter({
      to: discountEndDate?.unix(),
    });
  };
  const onChangeDateTo = (increment) => {
    if (discountEndDate !== null) {
      setSelectedDateOption(increment);
      if (increment === 1 || increment === 7) {
        const subtracted = discountEndDate.subtract(increment, "day");
        setDiscountStartDate(subtracted);
      }
      if (increment === 30) {
        const subtracted = discountEndDate.subtract(1, "month");
        setDiscountStartDate(subtracted);
      }
      if (increment === 90) {
        const subtracted = discountEndDate.subtract(3, "month");
        setDiscountStartDate(subtracted);
      }
      onFilter({
        from: discountStartDate?.unix(),
      });
    }
  };

  return (
    <>
      <div
        style={{
          boxShadow: "0px 1px 4px 0px rgba(0, 0, 0, 0.16)",
        }}
        className="mb-8 rounded-[4px]"
      >
        <div className="flex items-center px-5 pt-5 pb-[10px]">
          <div className="flex items-center">
            <span className="w-24">검색어</span>
            <div className="flex gap-4">
              <Dropdown
                width="w-36"
                positionDropdown={"top-10"}
                placeholder="상품명"
                textColor="text-black"
                options={checkByOptions}
                onClickItem={(id) => onFilter({ checkByOptions: id })}
              />
              <input
                type="text"
                className="h-8 w-[26rem] border border-button-grey rounded-[4px] p-2"
                placeholder="필터 선택 후, 검색"
              />
            </div>
          </div>
        </div>

        <div className="flex items-center px-5 pb-5 mt-1">
          <div className="flex items-center gap-[5rem] w-full">
            <div className="flex items-center">
              <span className="w-24">카테고리</span>
              <Dropdown
                width="w-36"
                positionDropdown={"top-10"}
                placeholder="카테고리 선택"
                textColor="text-black"
                options={categoriesData}
                onClickItem={(id) => onFilter({ categoryId: id })}
              />
            </div>

            <div className="flex text-secondary-grey items-center gap-[8px] w-1/2">
              <span className="w-12 text-title-black">기간</span>
              <InputDate
                value={discountStartDate}
                onChange={onChangeDiscountStartDate}
                defaultValue={discountStartDate}
              />
              {" - "}
              <InputDate
                value={discountEndDate}
                onChange={onChangeDiscountEndDate}
                defaultValue={discountEndDate}
              />
              <div
                className={`border ml-2 h-8 text-center rounded-[4px] border-button-grey flex divide-x text-[#bbbbbb]`}
              >
                <div
                  onClick={() => onChangeDateTo(1)}
                  className={`${
                    selectedDateOption === 1
                      ? "bg-primary-blue rounded-l-[4px] text-white"
                      : ""
                  } py-2 w-[42px] m-auto cursor-pointer text-[10px]`}
                >
                  오늘
                </div>
                <div
                  onClick={() => onChangeDateTo(7)}
                  className={`${
                    selectedDateOption === 7 ? "bg-primary-blue text-white" : ""
                  } py-2 w-[42px] m-auto cursor-pointer text-[10px] `}
                >
                  7일
                </div>
                <div
                  onClick={() => onChangeDateTo(30)}
                  className={`${
                    selectedDateOption === 30
                      ? "bg-primary-blue text-white"
                      : ""
                  } py-2 w-[42px] m-auto cursor-pointer text-[10px] `}
                >
                  1개월
                </div>
                <div
                  onClick={() => onChangeDateTo(90)}
                  className={`${
                    selectedDateOption === 90
                      ? "bg-primary-blue rounded-r-[4px] text-white"
                      : ""
                  } py-2 w-[42px] m-auto cursor-pointer text-[10px] `}
                >
                  3개월
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="pb-4 w-full border-t border-disable-grey " />
        <div className="pb-4 flex justify-center items-center">
          <Button
            onClick={onSubmitFilter}
            className="border p-1 border-secondary-grey"
            text="필터 검색"
          />

          <Button
            onClick={onResetFilter}
            className="border p-1 border-secondary-grey"
            text="필터 초기화"
          />
        </div>
      </div>
      <div className="border flex item-center border-input-grey bg-input-grey px-5 py-1.5">
        <h1 className="font-bold mr-6">정렬 필터</h1>
        {isOverall ? (
          <div className="flex gap-3">
            {overallRadioButton.map((item) => (
              <div className="flex items-center" key={item.id}>
                <input
                  type="radio"
                  className="mr-1 cursor-pointer accent-black"
                  name="alignmentFilter"
                />
                <span className="text-[11px]">{item.name}</span>
              </div>
            ))}
          </div>
        ) : isProductSpread ? (
          <div className="flex gap-3">
            {productRadioButton.map((item) => (
              <div className="flex items-center" key={item.id}>
                <input
                  type="radio"
                  className="mr-1 cursor-pointer accent-black"
                  name="alignmentFilter"
                />
                <span className="text-[11px]">{item.name}</span>
              </div>
            ))}
          </div>
        ) : (
          <div className="flex gap-3">
            {radioButton.map((item) => (
              <div className="flex items-center" key={item.id}>
                <input
                  type="radio"
                  className="mr-1 cursor-pointer accent-black"
                  name="alignmentFilter"
                />
                <span className="text-[11px]">{item.name}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}

export default Filter;
